module.exports = __webpack_public_path__ + "img/anzhen.3b67d37d.png";